import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PrefsProvider } from "@/context/PrefsContext";
import Protected from "@/components/Protected";
import AppShell from "@/components/AppShell";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Recipes from "@/pages/Recipes";
import BrewHub from "@/pages/BrewHub";
import RecipeEditor from "@/pages/RecipeEditor";
import Brew from "@/pages/Brew";
import Results from "@/pages/Results";
import Account from "@/pages/Account";
import Saved from "@/pages/Saved";
import Preferences from "@/pages/Preferences";
import Profile from "@/pages/Profile";
import InfoPage from "@/pages/InfoPage";
import Admin from "@/pages/Admin";

const shell = (node, showNav = true) => (
  <Protected>
    <AppShell showNav={showNav}>{node}</AppShell>
  </Protected>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PrefsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<Admin />} />

            <Route path="/" element={shell(<Home />)} />
            <Route path="/recipes" element={shell(<Recipes />)} />
            <Route path="/brew-guide" element={shell(<BrewHub />)} />
            <Route path="/brew-setup/:slug" element={shell(<RecipeEditor />, false)} />
            <Route path="/brew" element={<Protected><Brew /></Protected>} />
            <Route path="/results" element={shell(<Results />, false)} />

            <Route path="/account" element={shell(<Account />)} />
            <Route path="/account/saved" element={shell(<Saved />, false)} />
            <Route path="/account/preferences" element={shell(<Preferences />, false)} />
            <Route path="/account/profile" element={shell(<Profile />, false)} />

            <Route path="/about" element={shell(<InfoPage type="about" />, false)} />
            <Route path="/help" element={shell(<InfoPage type="help" />, false)} />
            <Route path="/contact" element={shell(<InfoPage type="contact" />, false)} />
            <Route path="/terms" element={shell(<InfoPage type="terms" />, false)} />
            <Route path="/privacy" element={shell(<InfoPage type="privacy" />, false)} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
        </PrefsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
